/* Click Fencing - the panel summary that disagreed with the drawing (blade + flat top +
 * PerfMesh).
 *
 * 1. RETIRED 2026-09-11 - THE CUT-PANEL CONVERSION KIT IS NO LONGER ADDED HERE.
 *    This file used to add ONE job-wide "PerfMesh Cut Panel Conversion Kit" line
 *    (PERF-CUT-KIT-BLK / -MON / -WHT) counting every cut panel in the job, at a hard-coded
 *    $111.77. cf-perfmesh-cut-parts.js has since taken that part over, one line per
 *    section, at the live Shopify price (CF_PRICE). With both running, this file found the
 *    FIRST per-section kit line and overwrote its quantity with the whole-job count, so
 *    every kit was billed twice - and it also counted panels of 970mm or less, which are
 *    1m PerfMesh Panel Kits and already carry their own stiles and channel.
 *
 *    Measured on preview 141671006302, 6 sections 4000/2500/3100/1800/5200/2200, satin
 *    black - 4 cut panels (S2 2400, S4 1700, S5 2050, S6 2100; S1's 850 is a 1m kit):
 *      Section 2 "Cut Panel Conversion Kit x 5 @ $111.77" + x1 each on S4, S5, S6 = 8 kits
 *      calculator screen $7,008.50   saved quote and cart $6,951.65   correct $6,515.94
 *    The cart held 8 kits: "Cut Panel Conversion Kit - $928.27 ($111.77 each x 8)".
 *
 *    The rule now lives in one place, cf-perfmesh-cut-parts.js classify(): a panel is a cut
 *    if it is wider than 970mm and not a stocked 2000 or 3000; <= 970 is a 1m kit.
 *
 * 2. THE PANEL SUMMARY DISAGREED WITH THE DRAWING. The "Panels: ..." text on Review reads
 *    optimizedConfigs.panelWidths, which only sometimes matches the drawn cut plan.
 *    Measured 2026-08-31, both on the same screen:
 *      blade 6000 + gate  summary 80mm, 2350mm, 2400mm   drawing 2350 | 920 gate | 1900 | 580
 *      mesh  4000 + gate  summary 1 x 2000mm             drawing 2000 | 970 gate | 830
 *    Same totals and the same price either way, so no money moved - but an installer cutting
 *    to the summary cuts different pieces from the ones drawn, and the mesh summary silently
 *    dropped a whole panel. Rebuilt from renderedPanels so it always matches the picture.
 *
 * Shape follows cf-calc-fixes.js: IIFE, prototype flag, polled install with a try limit,
 * every wrapper in try/catch so a display fix can never break the calculator.
 */
(function () {
  'use strict';

  var IS_ALU  = /(blade-fence-calculator|flat-top-fence-calculator|perfmesh-fence)/.test(location.pathname);
  if (!IS_ALU) return;

  var TRIES = 0, MAX_TRIES = 200;

  function inst() { return window.glassCalculator || window.glassFencingCalculator || null; }

  function sectionNums(fc) {
    try {
      return Object.keys(fc.state.sections || {})
        .map(Number).filter(function (n) { return !isNaN(n); })
        .sort(function (a, b) { return a - b; });
    } catch (e) { return []; }
  }

  // Drawn panels only - excludes gate, hinge and rake entries.
  function drawnPanels(fc, n) {
    try {
      var s = fc.state.sections[n];
      var rp = s && s.renderedPanels;
      if (Object.prototype.toString.call(rp) !== '[object Array]') return null;
      var out = [];
      for (var i = 0; i < rp.length; i++) {
        var p = rp[i];
        if (!p) continue;
        if (String(p.type || '').toLowerCase() !== 'panel') continue;
        var w = parseInt(p.width, 10);
        if (w > 0) out.push(w);
      }
      return out;
    } catch (e) { return null; }
  }

  // "Panels: 1730mm(x1), 2000mm(x3)" rebuilt from the drawn plan.
  function panelSummary(panels) {
    var counts = {}, i, w, keys = [];
    for (i = 0; i < panels.length; i++) {
      w = panels[i];
      if (!counts[w]) { counts[w] = 0; keys.push(w); }
      counts[w]++;
    }
    keys.sort(function (a, b) { return a - b; });
    var parts = [];
    for (i = 0; i < keys.length; i++) parts.push(keys[i] + 'mm(×' + counts[keys[i]] + ')');
    return parts.join(', ');
  }

  function fixSummaries(fc) {
    try {
      var els = document.querySelectorAll('.section-preview-details');
      if (!els.length) return;
      var nums = sectionNums(fc);
      for (var i = 0; i < els.length && i < nums.length; i++) {
        var el = els[i], txt = el.textContent.replace(/\s+/g, ' ').trim();
        if (txt.indexOf('Panels:') < 0) continue;
        var panels = drawnPanels(fc, nums[i]);
        if (!panels || !panels.length) continue;
        var want = panelSummary(panels);
        var next = txt.replace(/Panels:\s*[^|]*/, 'Panels: ' + want + ' ');
        if (next !== txt) el.textContent = next;
      }
    } catch (e) {}
  }

  function applyAll(fc) {
    if (!fc) return;
    try { fixSummaries(fc); } catch (e) {}
  }

  var timer = null;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { applyAll(inst()); }, 200);
  }

  function install() {
    var fc = inst();
    if (!fc || !fc.state) return false;
    var P = Object.getPrototypeOf(fc);
    if (!P || P.__cfMeshParts) return true;

    // updateQuoteSummary re-renders the Review summaries, so they are corrected after it.
    if (typeof P.updateQuoteSummary === 'function') {
      var o = P.updateQuoteSummary;
      P.updateQuoteSummary = function () {
        var r = o.apply(this, arguments);
        try { fixSummaries(this); } catch (e) {}
        return r;
      };
    }

    try {
      var root = document.querySelector('.calculator-content') || document.body;
      if (window.MutationObserver) {
        new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      }
    } catch (e) {}

    P.__cfMeshParts = true;
    schedule();
    try { console.log('[cf-mesh-parts] installed (summary only - cut kit retired 2026-09-11)'); } catch (e) {}
    return true;
  }

  function tryInstall() {
    var done = false;
    try { done = install(); } catch (e) {}
    if (done) return;
    if (++TRIES < MAX_TRIES) setTimeout(tryInstall, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInstall);
  } else {
    tryInstall();
  }
})();
